import styled from 'styled-components'

import type { ChildrenProps, ClassNameProps } from '@root/shared/react'

type PageSectionProps = {} & ClassNameProps & ChildrenProps

export const PageSection = ({ className, children }: PageSectionProps) => {
  return <Root className={className}>{children}</Root>
}

PageSection.Title = styled.div`
  color: var(--text-12);
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
`

const Root = styled.div`
  border-radius: 12px;
  border: 1px solid var(--background-3);
  background: var(--background-1);
  overflow: hidden;
`
